import type { Prices } from "@b2bportal/core-types";

/**
 * Determines if a price is a "fixed price" (paid in points) based on the base price.
 * Fixed price flights have a fiat value of 0 and include "Fixed" in the currency description.
 *
 * @param prices - The price object containing fiat and account-specific pricing
 * @param rewardsAccountId - The rewards account ID to check
 * @returns true if this is a fixed price (points-only) flight
 */
export const getIsFixedPriceFromBasePrice = (
  prices: Prices,
  rewardsAccountId: string
) => {
  return (
    prices.fiat?.value === 0 &&
    prices.accountSpecific[rewardsAccountId] &&
    prices.accountSpecific[rewardsAccountId]?.currencyDescription?.includes(
      "Fixed"
    )
  );
};
